/** Base URL for Matrize API (set REACT_APP_API_URL at build time for production). */
export const API_BASE =
  process.env.REACT_APP_API_URL || "https://api.matrizesurvey.in";

export const SESSION_KEY = "matrize_session";
